import { Coordinate } from 'ol/coordinate';
import { LineString, MultiLineString } from 'ol/geom';
import WKT from 'ol/format/WKT';

import { SeismicCalculator } from '../models/classes/SeismicCalculator';
import { ISurveyMetadata } from '../models/interfaces/ISurveyMetadata';
import { getTrace } from 'features/seismic/utils/calculateScreenValuesUtils';
import { ILineString } from '../models/interfaces/ILineString';
import { SurveyType } from '../models/enums/SurveyType';
import { IVolumeDebugInfo } from '../models/interfaces/IVolumeDebugInfo';

export function mouseToMap(calculator: SeismicCalculator | null, surveyMetadata: ISurveyMetadata | null, coordinate: Coordinate, dataGeometryLine: ILineString | null, isInverted: boolean, scaleX: number,
    geometrySeismic: (LineString | undefined)[] | undefined, volumeLimits: IVolumeDebugInfo[] | undefined | null = null
):Coordinate | null {
    if (!calculator || !surveyMetadata) {
        return null;
    }

    const increment = calculator.getLineIncrement(surveyMetadata);
    const startSurvey = calculator.getMinTrace(surveyMetadata);
    const endSurvey = calculator.getMaxTrace(surveyMetadata);
    let maxTrace = dataGeometryLine?.Max ?? surveyMetadata.Survey3DInfo.XlineEnd;
    let minTrace = dataGeometryLine?.Min ?? surveyMetadata.Survey3DInfo.XlineStart;
    let totalTraces = dataGeometryLine?.TotalTraces ?? maxTrace - minTrace;

    let mousePosition = coordinate[0];
    if (isInverted) {
        let deltaTotalCurrentCursor = (((endSurvey - startSurvey) * scaleX / increment + startSurvey) - mousePosition);
        mousePosition = startSurvey + deltaTotalCurrentCursor;
    }

    let xPosition = getTrace(mousePosition, scaleX, startSurvey, increment);

    let mouseCoordinate: Coordinate = [0, 0];

    let geom : LineString | null = null;

    if (!!geometrySeismic) {

        if (!!volumeLimits && volumeLimits.length > 0) {
            volumeLimits.forEach((volumeLimit, i) => {
                if (xPosition > volumeLimit.StartTrace && xPosition < volumeLimit.EndTrace && !!geometrySeismic[i]) {
                    geom = geometrySeismic[i]!;
                    xPosition = xPosition - volumeLimit.StartTrace;
                    minTrace = volumeLimit.StartTrace;
                    maxTrace = volumeLimit.EndTrace;
                    totalTraces  = volumeLimit.EndTrace - volumeLimit.StartTrace;
                }
            });
        }
        else {
            if (!!dataGeometryLine?.Segments && dataGeometryLine?.Segments.length > 0) {
                for (let i = 0; i < dataGeometryLine.Segments.length; i++) {
                    let segment = dataGeometryLine.Segments[i];
                    if (xPosition > segment.StartTrace && xPosition < segment.EndTrace && !!segment.LineWkt) {
                        geom = (new WKT().readGeometry(segment.LineWkt) as LineString);
                        xPosition = xPosition - segment.StartTrace;
                        minTrace = segment.StartTrace;
                        maxTrace = segment.EndTrace;
                        totalTraces  = segment.EndTrace - segment.StartTrace;
                        break;
                    }
                }
            } else {
                geom = geometrySeismic[0] ?? null;
            }
        }

        if (!geom) {
            return null;
        }

        let linePositionFraction = 0;
        if (surveyMetadata.Type === SurveyType.Seismic3D){
            linePositionFraction = (xPosition - minTrace) / (maxTrace - minTrace);
        }
        else {
            linePositionFraction = (xPosition) / (totalTraces);
        }

        if (linePositionFraction < 0) {
            linePositionFraction = 0;
        }
        else if (linePositionFraction > 1) {
            linePositionFraction = 1;
        }

        mouseCoordinate = geom.getCoordinateAt(linePositionFraction);
        /*if (geom.getCoordinates().length / totalTraces < 0.99) {
            mouseCoordinate = geom.getCoordinateAt(linePositionFraction);
        } else {
            if (!isInverted) {
                mouseCoordinate = geom.getCoordinates()[xPosition];
            }
            else  {
                mouseCoordinate = geom.getCoordinates()[totalTraces - xPosition];
            }
        }*/
    }

    if (isNaN(mouseCoordinate[0]) || isNaN(mouseCoordinate[1])){
        return null;
    }

    return mouseCoordinate;
}